/**
 * Every timer in the player goes through this interface so the headless harness can
 * run a seven-day offline scenario without waiting seven days.
 */

export type Cancel = () => void;

export interface Timer {
  now(): number;
  after(ms: number, fn: () => void): Cancel;
  every(ms: number, fn: () => void): Cancel;
  sleep(ms: number): Promise<void>;
}

export const systemTimer: Timer = {
  now: () => Date.now(),
  after: (ms, fn) => {
    const handle = setTimeout(fn, ms);
    return () => {
      clearTimeout(handle);
    };
  },
  every: (ms, fn) => {
    const handle = setInterval(fn, ms);
    return () => {
      clearInterval(handle);
    };
  },
  sleep: (ms) =>
    new Promise((resolve) => {
      setTimeout(resolve, ms);
    }),
};
